module.exports = __webpack_public_path__ + "static/media/poppins-regular.e212f840.ttf";